import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sidebarMenu } from '@/config/config';
import { logout } from '@/utils/common';

interface SidebarItemProps {
  icon: string;
  label: string;
  path?: string;
  submenu?: { label: string; path: string }[];
  sidebarOpen: boolean;
  locationPath: string;
}

const SidebarItem = ({ icon, label, path, submenu, sidebarOpen, locationPath }: SidebarItemProps) => {
  const [openSubmenu, setOpenSubmenu] = useState(false);
  const isActive = path ? locationPath === path : false;

  if (submenu) {
    return (
      <div>
        <div
          onClick={() => setOpenSubmenu(!openSubmenu)}
          className={`flex items-center px-3 py-2 rounded-xl cursor-pointer transition-colors duration-200
            ${openSubmenu ? 'text-blue-400' : 'text-gray-400 hover:text-blue-400'}
          `}
        >
          <i className={`${icon} text-lg transition-colors duration-200`}></i>
          {sidebarOpen && (
            <span className="ml-3 text-sm font-medium">{label}</span>
          )}
          {sidebarOpen && (
            <i
              className={`ri-arrow-down-s-line ml-auto transition-transform duration-200 ${
                openSubmenu ? 'rotate-180' : ''
              }`}
            ></i>
          )}
        </div>

        {sidebarOpen && openSubmenu && (
          <div className="ml-6 mt-1 space-y-1">
            {submenu.map((subItem, idx) => {
              const isSubActive = locationPath === subItem.path;
              return (
                <Link
                  key={idx}
                  to={subItem.path}
                  className={`block px-3 py-2 text-sm rounded-xl transition-colors duration-200
                    ${isSubActive ? 'text-blue-400 font-bold' : 'text-gray-300 hover:text-blue-400'}`}
                >
                  {subItem.label}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={path!}
      className={`flex items-center px-3 py-2 rounded-xl transition-colors duration-200
        ${isActive ? 'text-blue-400 font-bold' : 'text-gray-200 hover:text-blue-400'}`}
    >
      <i
        className={`${icon} text-lg transition-colors duration-200 ${
          isActive ? 'text-blue-400' : 'text-gray-400 hover:text-blue-400'
        }`}
      ></i>
      {sidebarOpen && <span className="ml-3 text-sm font-medium">{label}</span>}
    </Link>
  );
};

export default function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  return (
    <div
      className={`flex flex-col transition-all duration-300 ${
        sidebarOpen ? 'w-64' : 'w-20'
      } bg-gray-900 border-r border-gray-800 shadow-xl`}
    >
      <div className="p-4 border-b border-gray-800 flex items-center justify-between">
        {sidebarOpen && (
          <h1 className="text-xl font-bold text-gray-100 tracking-tight">
            Accord Hotel
          </h1>
        )}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <i className={`ri-${sidebarOpen ? 'menu-fold' : 'menu-unfold'}-line text-xl`}></i>
        </button>
      </div>

      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        {sidebarMenu.map((item, idx) => (
          <SidebarItem
            key={idx}
            {...item}
            sidebarOpen={sidebarOpen}
            locationPath={location.pathname}
          />
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-800">
        <button
          onClick={logout}
          className="flex w-full items-center px-3 py-2 rounded-xl text-gray-200 hover:text-red-500 transition-colors font-semibold"
        >
          <i className="ri-logout-box-line text-lg"></i>
          {sidebarOpen && <span className="ml-3 text-sm font-medium">Đăng xuất</span>}
        </button>
      </div>
    </div>
  );
}
